// extracted by mini-css-extract-plugin
export default {"totalCountWrap":"TotalCount_totalCountWrap__jnTgR","totalCount":"TotalCount_totalCount__Omak8","isActive":"TotalCount_isActive__qCIuQ"};